import React from 'react';
import {Loading} from '@carbon/react';
import {Time, Renew} from '@carbon/icons-react';
import {ProcessingProgressProps} from './types';

export interface QueueStatusProps {
    filesAhead?: number;
}

export const QueueStatus: React.FC<QueueStatusProps> = ({filesAhead = 0}) => {
    const queueText = filesAhead === 0
        ? 'In queue (next in line)'
        : `In queue (${filesAhead} file${filesAhead > 1 ? 's' : ''} ahead)`;

    return (
        <div className="queue-status-section">
            <h4>
                <Time size={16} style={{verticalAlign: 'middle', marginRight: '0.5rem'}} />
                {queueText}
            </h4>
            <p className="queue-message">
                Processing will begin automatically once earlier files have finished.
            </p>
        </div>
    );
};

export const ProcessingProgress: React.FC<ProcessingProgressProps> = ({
    currentStage,
    totalStages,
    stageName,
    detail,
    timeRemaining,
    startedAt
}) => (
    <div className="processing-progress-section">
        <div className="progress-icon">
            <Renew size={20} className="processing-icon rotating" />
        </div>
        <div className="progress-content">
            <h4>Processing in progress</h4>
            <p className="progress-stage">Stage {currentStage} of {totalStages}: {stageName}</p>
            <p className="progress-detail">{detail}</p>
            {timeRemaining && <p className="progress-time">~ {timeRemaining} remaining</p>}
            <p className="progress-started">Processing started: {startedAt}</p>
            <p className="progress-notification">You'll be notified when processing is complete.</p>
        </div>
    </div>
);

export const LoadingDetails: React.FC = () => (
    <div className="loading-details-section">
        <div className="loading-spinner">
            <Loading withOverlay={false} />
        </div>
        <h4 className="loading-title">Loading file details...</h4>
        <p className="loading-message">
            We're fetching the complete processing history and stage information for this file.
            This should only take a moment.
        </p>
    </div>
);
